/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const mobileSearch = () => {
  const mobileSearchButton = document.querySelectorAll('.js-mobile-search');
  const siteHeader = document.querySelector('.c-header');
  const menuMobile = document.querySelector('.c-header__mobile');
  const mobileOverlay = document.querySelector('.mobile-overlay');
  const burgerButton = document.querySelector('.js-menu-burger');
  const headerSearch = document.querySelector('.c-header__search');

  mobileSearchButton.forEach(button => {
    button.addEventListener(
      'click',
      event => {
        siteHeader.classList.toggle('c-header--search-open');
        siteHeader.classList.remove('c-header--mobile-open');

        if (button.classList.contains('c-header__search-mobile--collapse')) {
          mobileOverlay.classList.add('u-hidden');
        } else {
          mobileOverlay.classList.remove('u-hidden');
        }
        button.classList.toggle('c-header__search-mobile--collapse');
        headerSearch.classList.toggle('u-hidden@less-then-large');

        menuMobile.classList.add('u-hidden');
        burgerButton.classList.remove('c-burger--collapse');
      },
      true,
    );
  });

  const searchButton = document.querySelectorAll('.js-search-button');
  const menu = document.querySelector('.js-menu');
  const close = document.querySelector('.js-close-button');
  const icon = document.querySelector('.js-search-item');
  searchButton.forEach(button => {
    button.addEventListener(
      'click',
      event => {
        headerSearch.classList.toggle('u-hidden');
        close.classList.toggle('u-hidden');
        icon.classList.toggle('u-hidden');
        menu.classList.toggle('u-hidden');
      },
      true,
    );
  });
};

export default mobileSearch;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/mobileSearch.js